import { createConsumer } from "@rails/actioncable"

const consumer = createConsumer()
window.TurboCableConsumer = consumer    // ← expose-le pour ta console
export default consumer
